<!--suppress CssUnresolvedCustomProperty -->
<template>
    <div class="bg_main">
        <!--   TABLE FOR PROCESSES (TABLETS AND PC)   -->
        <v-row>
            <v-col cols="12">
                <v-card class="py-2 px-4">

                    <v-card-title class="text-center text-pantone  text-family">
                        Información General del Trámite
                    </v-card-title>

                    <v-divider class="mt-2 mb-4"></v-divider>

                    <v-card-text class="text-center">
                        <v-card-subtitle class="text-h6 text-pantone-black text-family">{{ $route.params.processName}}</v-card-subtitle>
                        <v-btn :to="{name: 'procedure_create', params: {processId: $route.params.processId}}" :color="pantoneBlack" class="white--text text-family"   x-large>
                                INICIAR TRÁMITE
                        </v-btn>
                        <v-container>
                            <v-card-subtitle class="hidden-md-and-up text-h6 text-family">
                                {{ $route.params.processName}}
                            </v-card-subtitle>

                            <div class="text-left my-4 text-family">
                                A continuación ponemos a tu disposición información relacionada con el trámite a manera de pestañas.
                                Para ver la información de la sección de tu interés, haz clic en la pestaña correspondiente y lee detenidamente su contenido.
                            </div>

                            <div class="text-left text-family">
                                <b>IMPORTANTE:</b> Si deseas realizar este trámite, haz clic en el botón de arriba y sigue las instrucciones conforme se vayan solicitando al avanzar tu trámite.
                            </div>
                        </v-container>
                    </v-card-text>

                    <v-divider class="mt-2 mb-4"></v-divider>
                    <v-container>
                        
                        <v-tabs v-model="tab" show-arrows grow :color="pantoneBlack">
                            <v-tabs-slider class="divisor_bajo text-family" :color="pantoneBackground"></v-tabs-slider>
                            <v-tab v-for=" tab in processesStore.processRequirements"  :key="tab.id" :color="pantoneBackground">
                                <span class="numero_requisitos mr-2 text-family">
                                    {{tab.position}}
                                </span>
                                <span>{{ tab.title }}</span>
                                <span class="flecha_divisor text-family"></span>
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab">
                            <v-tab-item v-for="tab in processesStore.processRequirements" :key="tab.id">
                                <v-card :color="pantoneBackground" flat>
                                    <v-card-text class="text-family" v-html="tab.content"></v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-container>

                </v-card>
            </v-col>
        </v-row>
        <!-- END TABLE FOR PROCESSES   -->

    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import {processRequirementsRequest} from "bestgob-core/api/models";

export default {
    name: "ProcessRequirements",
    components: {
    },
    computed: {
        ...mapState({account:state => state.account, processesStore: state => state.processes}),
    },
    data() {
        return {
            tab: null,
            pantone: '#B08C55',
            pantoneBlack: '#15212F',
            pantoneBackground: '#fff5d3'
        }
    },

    watch: {
        '$store.state.account.user'(){
            if (this.account.loggedIn){
                this.getRequirements()
            }
        },

        '$store.state.processes.processRequirements'(prerequirements){
            if (prerequirements && this.isGuestUser){
                this.verifyGuestUser()
            }
        }
    },

    mounted() {
        this.checkAuthentication()
    },

    methods: {
        ...mapActions('processes', ['getProcessRequirements']),
        ...mapActions('account', ['login', 'logout']),
        ...mapActions('alerts', ['error']),
        ...mapGetters('account', ['isGuestUser']),

        getRequirements(){
            let request = processRequirementsRequest()
            request.processId = this.$route.params.processId
            request.userId = this.account.user.id

            //Call from VueX
            this.getProcessRequirements(request)
        },

        checkAuthentication(){
            if (this.account.loggedIn){
                this.getRequirements();
            }else{
                let isInvited = this.$router.currentRoute.query.invited == 1

                if (isInvited){
                    this.requestLoginAsInvited()
                }else {
                    this.$router.push({name: 'login'})
                }
            }
        },

        requestLoginAsInvited(){
            let request = {username: process.env.VUE_APP_INVITED_USERNAME, password:  process.env.VUE_APP_INVITED_PASSWORD, client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID,   grant_type: 'password',}
            this.login(request)

        },

        verifyGuestUser(){
            if (!this.processesStore.processRequirementsShow){
                this.error(this.processesStore.processRequirements[0].content)
                this.logout()
            }
        },

        //TODO: $response->show = false; after get prerequisites
    },
}
</script>

<style scoped>

    .numero_requisitos{
        background-color:#fff5d3;
        padding: 5px 8px;
        margin-left: -30px;
    }

    .v-tab--active .numero_requisitos{
        color: #15212F;
        background-color: #fff5d3;
    }

    .v-tab--active .flecha_divisor{
        color: #fff5d3;
    }

    .flecha_divisor{
        color:#fff5d3;
        margin-left: 30px;
        margin-right: -70px;
    }

    .v-tab:last-child .flecha_divisor{
        display: none;
    }

    .divisor_bajo{
        display: none !important;
    }

    .v-tab--active{
        background-color: #fff5d3;
    }

</style>
